class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;

    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary ? this.summary.nextElementSibling : null;

    // Prevent default click behavior
    this.summary.addEventListener('click', (e) => e.preventDefault());

    // Hover behavior
    this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.close.bind(this));

    // Accessibility (keyboard focus)
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    requestAnimationFrame(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');

    const animations = this.content?.getAnimations() || [];
    animations.forEach((animation) => animation.play());
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');

    const animations = this.content?.getAnimations() || [];
    animations.forEach((animation) => animation.cancel());
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  open() {
    super.open();

    if (!this.header) return;
    this.header.preventHide = true;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    super.close();

    if (!this.header) return;
    this.header.preventHide = false;
  }
}

customElements.define('header-menu', HeaderMenu);